import React, { useContext, useState } from 'react'

import { PaymentsCard } from '@/types/fees'

export enum FlagsGroup {
  MainFlags = 0,
  OtherFlags = 1
}

export function getFlagsGroupText(flagsGroup: FlagsGroup) {
  return flagsGroup === FlagsGroup.MainFlags
    ? 'MasterCard e Visa'
    : 'Elo e Amex'
}

export function getCardBrandFromFlagsGroup(flagsGroup: FlagsGroup) {
  return flagsGroup === FlagsGroup.MainFlags
    ? PaymentsCard.Mastercard
    : PaymentsCard.Elo
}

interface Context {
  flagsGroup: FlagsGroup
  flagsGroupText: string
  setFlagsGroup(value: FlagsGroup): void
}

const FlagsGroupContext = React.createContext({
  flagsGroup: FlagsGroup.MainFlags,
  flagsGroupText: getFlagsGroupText(FlagsGroup.MainFlags)
} as Context)

export function useFlagGroup() {
  return useContext(FlagsGroupContext)
}

export function FlagsGroupContextProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [flagsGroup, setFlagsGroup] = useState(FlagsGroup.MainFlags)
  const flagsGroupText = getFlagsGroupText(flagsGroup)

  return (
    <FlagsGroupContext.Provider
      value={{ flagsGroup, flagsGroupText, setFlagsGroup }}
    >
      {children}
    </FlagsGroupContext.Provider>
  )
}
